<template>
  <v-row class="justify-center">
    <v-col md="">
      <v-card class="elevation-12">
        <v-card-title
          :class="BranchColor + ' white--text headline text-capitalize'"
        >
          <span class="mr-5">RETAIL</span>

          <!-- <v-spacer></v-spacer> -->
          <CartView SellType="retail" :StoreInfo="StoreInfo"></CartView>
          <v-spacer></v-spacer>
          <v-text-field
            solo
            dense
            class="mx-3"
            name="SearchText"
            label="SEARCH"
            id="Searchid"
            v-model.trim="search"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          show-select
          v-model="selectedList"
          item-key="_id"
          :loading="isLoading"
          :mobile-breakpoint="200"
          :headers="headers"
          :items="RetailProducts"
          :search="search"
        >
          <template v-slot:[`item.price`]="{ item }">
            {{ item.price.toLocaleString() }}
            <strong> {{ StoreInfo.CashBase | MoneySigns }}</strong>
          </template>
          <template v-slot:[`item.qty`]="{ item }">
            {{ item.qty.toLocaleString() }}
            <strong class="error--text">PCS</strong>
          </template>
          <template v-slot:[`item.cart`]="{ item }">
            <addToCartCMP :key="item.product" :ItemObj="item"></addToCartCMP>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    // paymentForm: () => import("./PaymentForm"),
    addToCartCMP: () => import("./Cart/AddToCart"),
    CartView: () => import("./Cart/CartView"),
  },
  props: {
    BranchColor: [String],
    StoreInfo: [Object],
    headers: [Array],
  },
  data() {
    return {
      search: "",
      selectedList: [],
    };
  },
  watch: {
    selectedList(v) {
      // console.log(v);
      this.$store.commit("RESET_CART");
      if (!v.length) return;
      v.forEach(ItemObj => {
        // eslint-disable-next-line no-unused-vars
        let { AccountName, invCateg, ...item } = ItemObj;
        this.$store.commit("DIRECT_CART", {
          ...item,
          // qty: this.QTY,
          // price: this.PRICE,
        });
      });
    },
  },
  computed: {
    ...mapGetters(["isLoading", "getProducts", "getGroupedProducts"]),
    RetailProducts() {
      return this.getGroupedProducts.map(prod => {
        // console.log(prod);
        // if (prod.InvName == "3311-19" && prod.code == "114=>115-49") {
        //   console.log(prod);
        //   console.log({ tst: (prod.qty * prod.UnitQty).toLocaleString() });
        // }
        return {
          ...prod,
          qty: Math.round(parseFloat((prod.qty * prod.UnitQty).toFixed(2))),
          price: parseFloat((prod.price / prod.UnitQty).toFixed(1)),
          retail: true,
        };
      });
    },
  },

  created() {
    // this.$store.commit("RESET_CART");
    console.log(this.getGroupedProducts.filter(item => item.codes.length > 2));

    this.$store.commit("CLEAR_CART_IF", { retail: true });
  },
};
</script>
